//
//
//
//
//
//
//

import { mapState } from 'vuex'

export default {
  data() {
    return {
      location: null,
    }
  },
  async validate({ $storyblok, params, store }) {
    try {
      let location = store.state.allLocations.find(l => {
        return l.path == params.pathMatch
      })
      if(location) {
        return true
      } else {
        let story = await $storyblok.getStory(`locations/${params.pathMatch}`)
        if(story) {
          return true
        } else {
          return false
        }
      }
    } catch(err) {
      return false
    }
  },
  async asyncData({ store, $storyblok, params }) {
    let location = store.state.allLocations.find(l => {
      return l.path == params.pathMatch
    })
    if(location) {
      return {
        location
      }
    } else {
      let story = await $storyblok.getStory(`locations/${params.pathMatch}`)
      if(story) {
        return {
          story
        }
      }
    }
  }
}
